import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CopyOutlined, DeleteOutlined, ExclamationCircleOutlined, ScanOutlined } from "@ant-design/icons";
import { observer } from "mobx-react";
import { useState } from "react";
import { AnalyseResult } from "./analyseResult.js";
const AnalyseItem = observer(({ attachment, onClick, style })=>{
    const [showImage, setShowImage] = useState(false);
    return /*#__PURE__*/ _jsxs("li", {
        "data-id": attachment.id,
        style: style,
        onClick: onClick,
        onMouseEnter: ()=>setShowImage(true),
        children: [
            /*#__PURE__*/ _jsx("sup", {
                children: attachment.id
            }),
            showImage && /*#__PURE__*/ _jsx("img", {
                src: attachment.thumbnailUrl
            }),
            /*#__PURE__*/ _jsxs("span", {
                children: [
                    attachment.filename,
                    " ",
                    !!attachment.error && /*#__PURE__*/ _jsxs("span", {
                        style: {
                            paddingLeft: 5,
                            color: "red"
                        },
                        children: [
                            /*#__PURE__*/ _jsx(ExclamationCircleOutlined, {}),
                            " ",
                            attachment.error
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(AnalyseResult, {
                children: [
                    /*#__PURE__*/ _jsxs("li", {
                        children: [
                            /*#__PURE__*/ _jsx(CopyOutlined, {}),
                            " ",
                            attachment.check.cntAvailable
                        ]
                    }),
                    attachment.check.cntMustGenerate > 0 && /*#__PURE__*/ _jsxs("li", {
                        children: [
                            /*#__PURE__*/ _jsx(ScanOutlined, {}),
                            " ",
                            attachment.check.cntMustGenerate
                        ]
                    }),
                    attachment.check.cntDeletable > 0 && /*#__PURE__*/ _jsxs("li", {
                        children: [
                            /*#__PURE__*/ _jsx(DeleteOutlined, {}),
                            " ",
                            attachment.check.cntDeletable
                        ]
                    })
                ]
            })
        ]
    });
});
export { AnalyseItem };
